import { SceneManager } from '../../managers/SceneManager';
import { CoreController } from '../../CoreController';

export interface LevelJson extends JSON {
    levelIndex: number;
    stacks: number;
    stackHeight: number;
    freeSpaces: number;
    shuffles: number;
    moves: number;
}

export class LevelManager {
    private static _instance: LevelManager;
    private levelJsons: LevelJson[];
    private levels: any[] = [];

    private readonly difficultyStep: number = 7;

    private constructor() {
        this.levelJsons = SceneManager.getInstance().getJson('levels').levels;
    }

    public static getInstance(): LevelManager {
        return this._instance || (this._instance = new this());
    }

    public getLevel(levelIndex: number): LevelJson {
        let levelJson: LevelJson = this.getLevelJson(levelIndex);
        if (!levelJson) {
            levelJson = this.generateLevel(levelIndex);
        }
        this.validateJson(levelJson);
        // console.log('EXPORTED LEVEL ' + levelJson.levelIndex);
        if (levelIndex < 31) {
            this.levels.push(levelJson);
        }
        return levelJson;
    }

    private generateLevel(levelIndex: number): LevelJson {
        const levelJson: LevelJson = {} as LevelJson;
        const factor: number = this.difficultyStep / 100;
        levelJson.levelIndex = levelIndex;
        levelJson.stacks = this.generateNumberOfStacks(levelIndex);
        levelJson.stackHeight = this.generateStackHeight(levelIndex);
        levelJson.freeSpaces = this.generateSpaces(levelIndex, levelJson.stackHeight);
        levelJson.shuffles = this.generateShuffles(levelIndex, levelJson.stackHeight, levelJson.freeSpaces);
        levelJson.moves = this.generateMoves(levelIndex, levelJson.stacks, levelJson.freeSpaces);

        return levelJson;
    }

    private getLevelJson(levelIndex: number): LevelJson | null {
        let result: LevelJson = null;
        const filteredArray: LevelJson[] = this.levelJsons.filter((level: LevelJson) => level.levelIndex === levelIndex);
        if (filteredArray.length > 0) {
            result = filteredArray[0];
        }
        return result;
    }

    private generateNumberOfStacks(levelIndex: number): number {
        const factor: number = this.difficultyStep / 100;
        let numberOfStacks: number = 3 + Math.floor(levelIndex * factor);
        if (numberOfStacks < 3) {
            numberOfStacks = 3;
        }
        return numberOfStacks;
    }

    private generateStackHeight(levelIndex: number): number {
        const factor: number = this.difficultyStep / 100;
        return 3 + Math.floor(1.5 + levelIndex * factor);
    }

    private generateSpaces(levelIndex: number, stackHeight: number): number {
        const intervalMax: number = 3 - Math.floor((levelIndex - 1) / this.difficultyStep / (this.difficultyStep - 1));
        const startPoint: number = this.difficultyStep * 3 - levelIndex;
        let intervalMin: number = 2 + Math.floor(startPoint / this.difficultyStep / (this.difficultyStep - 1));
        if (intervalMin < 0) {
            intervalMin = 0;
        }
        const levelInCycle: number = ((levelIndex - 1) % this.difficultyStep);
        const extraPerLevel: number = (intervalMax - intervalMin) / this.difficultyStep;
        const extraSpaces: number = Math.round(intervalMin + (this.difficultyStep - levelInCycle) * extraPerLevel);
        let freeSpaces: number = 3 + extraSpaces;
        if (freeSpaces >= stackHeight + 2) {
            freeSpaces = stackHeight + 1;
        }
        return freeSpaces;
    }

    private generateShuffles(levelIndex: number, stackHeight: number, freeSpaces: number): number {
        let shuffles: number;
        const chapterFactor: number = Math.floor(Math.floor((levelIndex / 10)) * 1.32);
        const spacesFactor: number = chapterFactor * freeSpaces;
        const heightFactor: number = chapterFactor * stackHeight * 2;
        shuffles = Math.floor(levelIndex * 6) + (chapterFactor * (spacesFactor + heightFactor));
        return shuffles;
        // return 1;
    }

    private generateMoves(levelIndex: number, numberOfStacks: number, freeSpaces: number): number {
        const chapter: number = 1 + Math.floor((levelIndex - 1) / 10);
        // const chapterDiff: number = 20 - CoreController.getInstance().getCurrentChapter();
        // const spacePerStack: number = Math.floor(freeSpaces / numberOfStacks);
        // return Math.floor(levelIndex * 0.5) + numberOfStacks * (5 - spacePerStack) + Math.floor(chapterDiff);
        return Math.floor(freeSpaces * (chapter + numberOfStacks) + chapter + (13 - chapter) / 2);
        // return 6;
    }

    private validateJson(levelJson: LevelJson): void {
        let added: boolean = false;
        if (!levelJson.stacks) {
            levelJson.stacks = this.generateNumberOfStacks(levelJson.levelIndex);
            added = true;
        }
        if (!levelJson.stackHeight) {
            levelJson.stackHeight = this.generateStackHeight(levelJson.levelIndex);
            added = true;
        }
        if (!levelJson.freeSpaces) {
            levelJson.freeSpaces = this.generateSpaces(levelJson.levelIndex, levelJson.stackHeight);
            added = true;
        }
        if (!levelJson.shuffles) {
            levelJson.shuffles = this.generateShuffles(levelJson.levelIndex, levelJson.stackHeight, levelJson.freeSpaces);
            added = true;
        }
        if (!levelJson.moves) {
            levelJson.moves = this.generateMoves(levelJson.levelIndex, levelJson.stacks, levelJson.freeSpaces);
            added = true;
        }
        if (added) {
            throw new Error('WARNING! MISSING INFO IN LEVEL JSON!!!!');
        }
        // levelJson.shuffles = 1;
        // levelJson.moves = 1;
        // tslint:disable-next-line:max-line-length
        // console.log('Nivel: ' + levelJson.levelIndex + ' | Culori: ' + levelJson.stacks + ' | Inaltime: ' + levelJson.stackHeight + ' | Spatii: ' + levelJson.freeSpaces + ' | Amestecari: ' + levelJson.shuffles + ' | Mutari: ' + levelJson.moves);
    }

    public exportToJsonFile(): void {
        const jsonData: any = {levels: this.levels};
        const dataStr: string = JSON.stringify(jsonData);
        const dataUri: string = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);

        console.log('%c Click the link to download JSON! ' + dataUri, 'background: #222; color: #bada55');
    }
}